import React, { useState } from "react";

import { SUPPORT_URL } from "../../../utils/support";
import ConfirmDialog from "./ConfirmDialog";
import { Icon } from "./icons";
import PastOrderCard, { reorderFailed } from "./PastOrderCard";

/**
 * Onglet Passées (« Mes commandes - Passees et detail », P01 à P05) : une
 * grille de cartes, l'aide en pied, et les deux alertes du mobile (reçu
 * indisponible, délai PEPPOL dépassé). Les commandes sont dans l'ordre du
 * serveur, comme sur mobile.
 */
export default function PastOrders({ orders, t, lang, now, onOpen, onReorder, onOpenCart, onReceipt, onPeppol }) {
  const [dialog, setDialog] = useState(null);

  if (!orders.length) {
    return (
      <div className="wosh-ord__empty wosh-ord__empty--past">
        <div className="wosh-ord__empty-icon">
          <Icon name="time-outline" />
        </div>
        <div className="wosh-ord__empty-title">{t("orders.noPastOrders")}</div>
        <div className="wosh-ord__empty-sub">{t("orders.noPastOrdersSub")}</div>
      </div>
    );
  }

  const close = () => {
    dialog?.onClose?.();
    setDialog(null);
  };

  const receiptFailed = (reset) =>
    setDialog({
      icon: "alert-circle",
      tone: "danger",
      title: t("pastOrderCard.receiptErrorTitle"),
      message: t("pastOrderCard.receiptErrorBody"),
      onClose: reset,
    });

  const peppol = (order, expired) => {
    if (expired) {
      setDialog({
        icon: "hourglass-outline",
        tone: "warning",
        title: t("pastOrderCard.peppolExpiredTitle"),
        message: t("pastOrderCard.peppolExpiredBody"),
      });
      return;
    }
    onPeppol(order);
  };

  return (
    <>
      <div className="wosh-po-grid">
        {orders.map((order) => (
          <PastOrderCard
            key={order.id}
            order={order}
            t={t}
            lang={lang}
            now={now}
            onOpen={onOpen}
            onReorder={onReorder}
            onOpenCart={onOpenCart}
            onReorderError={() => setDialog(reorderFailed(t))}
            onReceipt={onReceipt}
            onReceiptError={receiptFailed}
            onPeppol={peppol}
          />
        ))}
      </div>
      <p className="wosh-po-help">
        {t("orders.needHelp")}{" "}
        <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">
          {t("orders.contactSupport")}
        </a>
      </p>

      <ConfirmDialog
        open={Boolean(dialog)}
        icon={dialog?.icon}
        tone={dialog?.tone}
        title={dialog?.title}
        message={dialog?.message}
        confirm="OK"
        onCancel={close}
        onConfirm={close}
      />
    </>
  );
}
